<template>
  <v-container fluid>
    <VueApexCharts
      width="100%"
      height="300"
      type="bar"
      :options="options"
      :series="series"
    />
  </v-container>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ChartGautiMetai',
  components: {
    VueApexCharts,
  },
  props: {
    chart: Array,
    laikotarpis: String,
  },
  data() {
    return {
      //
    }
  },
  computed: {
    series() {
      let hipotekaData = []
      let ikeitimasData = []
      let vykdomasisData = []
      let sutartisData = []
      this.chart.forEach(item => {
        hipotekaData.push(item.hipoteka)
        ikeitimasData.push(item.ikeitimas)
        vykdomasisData.push(item.vykdomasis)
        sutartisData.push(item.sutartis)
      })
      return [
        {
          name: 'Hipotekos',
          data: hipotekaData,
        },
        {
          name: 'Įkeitimai',
          data: ikeitimasData,
        },
        {
          name: 'Vykdomieji įrašai',
          data: vykdomasisData,
        },
        {
          name: 'Sutartys',
          data: sutartisData,
        },
      ]
    },
    seriesDemo() {
      return [
        {
          name: 'Hipotekos',
          data: [30, 20, 41, 52, 30, 20, 41, 52, 30, 20, 41, 52],
        },
        {
          name: 'Įkeitimai',
          data: [20, 30, 21, 32, 20, 30, 21, 32, 20, 30, 21, 32],
        },
        {
          name: 'Vykdomieji įrašai',
          data: [20, 30, 21, 32, 20, 30, 21, 32, 20, 30, 21, 32],
        },
        {
          name: 'Sutartys',
          data: [20, 30, 21, 32, 20, 30, 21, 32, 20, 30, 21, 32],
        },
      ]
    },
    categories() {
      return this.chart.map(item => {
        return item.menesis
      })
    },
    options() {
      return {
        plotOptions: {
          bar: {
            distributed: false,
            borderRadius: 2,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          },
        },
        chart: {
          toolbar: {
            tools: {
              download: false,
            },
          },
        },
        dataLabels: {
          enabled: false,
          formatter: function(val) {
            return val
          },
          offsetY: -20,
          style: {
            fontSize: '10px',
            colors: ['#304758'],
          },
        },
        tooltip: {
          enabled: true,
          shared: true,
          intersect: false,
          x: {
            formatter: function(val) {
              return val
            },
          },
        },
        legend: {
          show: true,
        },
        xaxis: {
          categories: this.categories,
          position: 'bottom',
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            formatter: function(val) {
              return val.toString().slice(5)
            },
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: true,
            formatter: function(val) {
              return val
            },
          },
        },
        title: {
          text: `Gauti duomenys (${this.laikotarpis})`,
          floating: true,
          offsetY: 0,
          align: 'center',
          style: {
            color: '#444',
            fontSize: '16px',
            fontFamily: 'Open Sans',
          },
        },
      }
    },
  },
  created() {
    //
  },
  methods: {
    //
  },
}
</script>
